<template>
	<div class="document main-tab-o">
		<div class="bottom-line"></div>
		<div class="nd-path">
			<div class="ndp-c">
				<router-link to='/' class="ndp-link">首页</router-link>>>
			</div>
		</div>
		<!-- 公司介绍 -->
		<div v-if="isShow == 4" class="main-content">
			<h2 class="main-title">企业简介</h2>
			<div class="d-content">大连德音科技有限公司致力于音乐教育数字化的探索、实践与运营，专注于音乐基础知识的教学、互动、推广与传播。公司以“创新、实效、共享”为发展宗旨，开发了艺百理（App、小程序）系列产品，将为广大音乐教育机构、老师和学生提供服务。</div>
			<h2 class="main-title">产品简介</h2>
			<div class="d-content">教音基，学乐理，用艺百理。艺百理系列产品致力于音基乐理的教学与传播，专注为音基教学及推广提供服务；是集教学工具、课管工具、运营工具、推广工具于一体的智能教学互动软件。</div>
			<div class="d-content">艺百理App作为艺百理产品的教学端，专注于音基乐理的教学辅助，主要包括音基系统课程、考练题库、音乐知识、教学互动及作业跟进体系。产品紧扣社会艺术考级机构的教材大纲，通过灵活、便捷、高效的形式，展现课堂互动，丰富教学场景，提升音乐素养，助力音基考级。让音教机构和老师轻松开班，快乐授课；让考级学生和家长安心备战，顺利过关。</div>
			<div class="d-content">艺百理小程序作为艺百理产品的管理端，注册即可使用，普遍适用艺术类培训机构的师生。产品包含课表、班级、消息等模块；教师端具有班级管理、教师管理、学生管理、排课调课、上课签到、相关提醒、课时统计、推荐有奖等功能；学生端具有自主排课、查看课表、课前提醒、核对课时、考练体验、分享有礼等功能。小程序操作简单方便，体验高效流畅，是深受欢迎的音基教学助手和运营推广能手。</div>
		</div>
		<!-- 用户协议 || 隐私条款 -->
		<div v-if="isShow == 5 || isShow == 6" class="main-content">
			<h2 class="main-title">{{item.name}}</h2>
			<div class="main-content" v-html="item.content"></div>
		</div>
		<!-- 联系我们 -->
		<div v-if="isShow == 7" class="main-content main-content-link">
			<div class="btl-list">
				<div class="btll-items">
					<div class="btll-item"><span>客服微信：</span><span class="btlli-c">yibailiclass</span></div>
					<div class="btll-item"><span>服务时间：</span><span class="btlli-c">工作日9:00-17:00</span></div>
					<div class="btll-item"><span>电子邮箱：</span><span class="btlli-c">service@yibailiclass.com</span></div>
					<div class="btll-item"><span>联系地址：</span><span class="btlli-c">大连市西南路888号A9</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var that = null;
	import axios from 'axios'
	export default {
		name: 'document',
		data() {
			return {
				isShow: 4,
				id: 0,
				item: {}
			}
		},
		mounted() {
			that = this;
			this.isShow = parseInt(this.$route.query.id);
			switch (this.isShow) {
				case 4:
					break;
				case 5:
					this.getIndex(40)
					break;
				case 6:
					this.getIndex(39)
					break;
				default:
					break;
			}
		},
		watch: {
			$route(to, from) {
				this.isShow = to.query.id;
				if (to.query.id == 5) {
					this.getIndex(40)
				} else if (to.query.id == 6) {
					this.getIndex(39)
				}
			}
		},
		methods: {
			// 获取协议
			getIndex(id) {
				axios.get('https://pro.yibailiclass.com/api/index/getSecret', { // 还可以直接把参数拼接在url后边
					params: {
						id
					}
				}).then(function(res) {
					var result = res.data;
					if (result.status == 1) {
						that.item = result.data
					} else {
						alert(data.msg);
					}
				}).catch(function(error) {
					console.log(error);
				})
			}
		}
	}
</script>

<style scoped>
	.bottom-line{
		position: fixed;
		top: 100px;
		left: 50%;
		transform: translateX(-50%);
		width: 1000px;
		height: 1px;
		background-color: #999999;
	}
	.document {
		width: 1000px;
		margin: 100px auto 0;
		color: #333333;
		font-size: initial;
		text-align: left;
		padding: 0 0 4rem;
	}
	/* 路径 */
	.nd-path {
		width: 100%;
		text-align: left;
		font-size: 20px;
	}

	.ndp-link {
		color: #333;
		text-decoration: none;
	}

	.ndp-c {
		height: 60px;
		line-height: 60px;
	}
	
	/* end */

	.main-title {
		text-align: center;
	}

	.d-title {
		font-weight: bold;
	}

	.btll-item {
		line-height: 4rem;
	}

	.d-content {
		text-indent: 2rem;
		line-height: 1.5em;
		margin-bottom: 1rem;
	}

	.btlli-c {
		color: #898989;
	}

	.main-content-link {
		margin: 50px 0 80px 300px;
	}
</style>
